import { IStore } from '../index'
import { TClientDetailsItem } from '../../interfaces/IClientDetails'

export const getAllClientsValue = (state: IStore): TClientDetailsItem[] =>
  state.allClientsReducer
